import { ticketActions } from './action'

const initialState = {
  tickets: [],
  Activetickets: [],
  ticketComments: [],
  ticketAttatchment: [],
  techsupportUsers: [],
  totalCount: 0,
  selectedTicket: null,
  pagination: {
    skip: 0,
    limit: 10,
  },
  status: 'all',
}

export const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case ticketActions.GET_TICKETS:
      return {
        ...state,
        tickets: action.payload.tickets,
        totalCount: action.payload.totalCount,
      }
    case ticketActions.GET_ACTIVE_TICKETS:
      return {
        ...state,
        Activetickets: action.payload.Activetickets,
      }

    case ticketActions.CREATE_TICKET:
      return {
        ...state,
        tickets: [action.payload, ...state.tickets],
        totalCount: state.totalCount + 1,
      }

    case ticketActions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }

    case ticketActions.EDIT_TICKET:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      }
    case ticketActions.TICKET_HANDLE_STATUS:
      return {
        ...state,
        status: action.payload,
      }
    case ticketActions.GET_COMMENTS:
      return {
        ...state,
        ticketComments: action.payload.comments,
      }
    case ticketActions.GET_TICKET_ATTACHMENTS_BY_ID:
      return {
        ...state,
        ticketAttatchment: action.payload.attachments,
      }
    case ticketActions.GET_SINGLE_TICKET:
      return {
        ...state,
        selectedTicket: action.payload,
      }
    case ticketActions.GET_ALL_TECH_SUPPORT_USERS:
      return {
        ...state,
        techsupportUsers: action.payload,
        // totalCount: action.payload.totalCount,
      }
    default:
      return state
  }
}
